import { Grid } from "@mui/material";
import { useEffect, useState } from "react";

import Box from "../Box";
import Modal from "../Modal";
import Avatar from "../Avatar";
import Switch from "../Switch";
import Typography from "../Typography";
import Autocomplete from "../Autocomplete";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import Resources from "../../constants/resources";

import { ICodename } from "../../commons/interfaces";
import { IRecordWorkingGroup } from "./cardUserGroup";
import { GroupUserDefault, IsTrue, Mode, } from "../../constants/enums";



const ModalUpdateWorkingGroup = (props: {
    mode: number;
    visibleModal: boolean;

    newLableGroup?: string;
    newLableStaff?: string;

    dataUserTitleSelect: ICodename[];
    isPermissionCheckGroupManager: boolean;

    dataDetail: IRecordWorkingGroup | undefined;

    onCloseModal: () => void;
    onActionModal: (newItem: IRecordWorkingGroup | undefined) => void;
}) => {
    const strings = useStrings();

    const [dataWorkingGroup, setDataWorkingGroup] = useState<IRecordWorkingGroup | undefined>(undefined);

    useEffect(() => {
        if (props.visibleModal) {
            if (!Helpers.isNullOrEmpty(props.dataDetail?.groupId)) {
                setDataWorkingGroup(props.dataDetail)
            } else {
                setDataWorkingGroup(undefined)
            }
        }
    }, [props.dataDetail?.id]);

    return (
        <Modal
            fullWidth
            hasActionButton
            maxWidth={"sm"}
            visible={props.visibleModal}
            title={strings.Common.UPDATE}
            onClose={() => {
                props.onCloseModal();
                setDataWorkingGroup(undefined);
            }}
            onAction={() => {
                props.onActionModal(dataWorkingGroup);
                setDataWorkingGroup(undefined);
            }}
        >
            <Grid container spacing={3} padding={2}>
                <Grid item xs={12} md={12}>
                    <Box sx={{
                        gap: 1,
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        borderBottom: "1px solid #dddddd",
                        paddingBottom: "12px",
                    }}>
                        <Avatar
                            src={Resources.IMAGES.TEAM}
                            text={dataWorkingGroup?.groupName}
                            sx={{
                                width: "5rem",
                                height: "5rem",
                                marginLeft: "16px",
                                marginRight: "16px",
                                border: "1px #dddddd solid",
                            }}
                        />
                        <Box display="grid">
                            <Typography variant="button">
                                {strings.format(strings.Group.CODE_GROUP, props.newLableGroup)}:&nbsp;
                                <Typography variant="button" fontWeight="bold">
                                    {dataWorkingGroup?.groupCode}
                                </Typography>
                            </Typography>

                            <Typography variant="button">
                                {strings.format(strings.Group.NAME_GROUP, props.newLableGroup)}:&nbsp;
                                <Typography variant="button" fontWeight="bold">
                                    {dataWorkingGroup?.groupName}
                                </Typography>
                            </Typography>

                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                    <Box sx={{
                        gap: 1,
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}>
                        <Switch
                            disabled={(props.mode === Mode.View)}
                            checked={Number(dataWorkingGroup?.default) === GroupUserDefault.Default}
                            onChange={(event, checked) => {
                                const value = checked ? GroupUserDefault.Default : GroupUserDefault.None;
                                setDataWorkingGroup(prev => ({
                                    ...prev,
                                    default: value,
                                }));
                            }}
                        />
                        <Typography variant="button" fontWeight={"bold"}>
                            {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.GROUP_DEFAULT, props.newLableGroup))}
                        </Typography>
                    </Box>
                </Grid>

                {
                    props.isPermissionCheckGroupManager &&
                    <Grid item xs={12} md={12}>
                        <Box sx={{
                            gap: 1,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                        }}>
                            <Switch
                                disabled={(props.mode === Mode.View)}
                                checked={Number(dataWorkingGroup?.manager) === IsTrue.True}
                                onChange={(event, checked) => {
                                    let value = checked ? IsTrue.True : IsTrue.False;
                                    setDataWorkingGroup(prev => ({
                                        ...prev,
                                        manager: value,
                                    }));
                                }}
                            />
                            <Typography variant="button" fontWeight={"bold"}>
                                {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.MANAGER_GROUP, props.newLableGroup))}
                            </Typography>
                        </Box>
                    </Grid>
                }

                <Grid item xs={12} md={12}>
                    <Autocomplete
                        mode={props.mode}
                        data={props.dataUserTitleSelect || []}
                        defaultValue={dataWorkingGroup?.userTitle}
                        label={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.STAFF_POSITION, props.newLableStaff))}
                        placeholder={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.SELECT_STAFF_POSITION, props.newLableStaff))}
                        onChange={(value) => {
                            setDataWorkingGroup(prev => ({
                                ...prev,
                                userTitle: value,
                            }))
                        }}
                    />
                </Grid>
            </Grid>
        </Modal>
    );
};

export default ModalUpdateWorkingGroup;